import fakeEquipmentImage from "../public/equipment/equipment.jpg";

/** Demo optional / paid equipment; keep in sync with studio profile until API fills `optionalBookableEquipment`. */
export const FAKE_PAID_EQUIPMENT = [
    // {
    //     id: "fake-paid-1",
    //     category: "Audio",
    //     nameModel: "Rode Mikrofon 201 Rode Mikrofon 201 Rode Mikrofon 201 ",
    //     pricePerPiece: 14,
    //     description:
    //         "Kompaktes Kondensatormikrofon mit Spinne und Popschutz; klare Abnahme für Sprache und Gesang.",
    //     imageUrl: fakeEquipmentImage,
    // },
    // {
    //     id: "fake-paid-2",
    //     category: "Licht",
    //     nameModel: "Dauerlicht-Set Softbox",
    //     pricePerPiece: 22.5,
    //     quantity: 8,
    //     description:
    //         "LED-Dauerlicht mit Softbox und höhenverstellbarem Stativ; flicktfreies Licht für Foto und Video.",
    //     imageUrl: fakeEquipmentImage,
    // },
    // {
    //     id: "fake-paid-3",
    //     category: "Audio",
    //     nameModel: "Studiokopfhörer Pro",
    //     pricePerPiece: 8.9,
    //     quantity: 20,
    //     description:
    //         "Geschlossener Studiokopfhörer, linear; detailreiches Monitoring beim Mischen und Schnitt am Rechner.",
    //     imageUrl: fakeEquipmentImage,
    // },
    // {
    //     id: "fake-paid-4",
    //     category: "Effekte",
    //     nameModel: "Hallpedal Studio",
    //     pricePerPiece: 6,
    //     description:
    //         "Hallpedal mit Studio-Algorithmen und Stereoeingang; räumliche Sounds für Gitarre und Synthesizer.",
    //     imageUrl: fakeEquipmentImage,
    // },
    // {
    //     id: "fake-paid-5",
    //     category: "Foto",
    //     nameModel: "Reflektor-Kit 5-in-1",
    //     pricePerPiece: 11,
    //     quantity: 10,
    //     description:
    //         "Reflektor-Set fünfteilig mit Klappstativ; Highlights und Schatten bei Portraits gezielt steuern.",
    //     imageUrl: fakeEquipmentImage,
    // },
];
